import { graphql } from "../../graphql"

export const query = graphql(`
  query JourneyCount {
    productCategories(isJourney: true) {
      pageInfo {
        totalItemCount
      }
    }
  }
`)
